<script>
  import SettingsLayout from '../../components/SettingsLayout.svelte';
  import { settingsStore } from '../../stores/settingsStore.js';

  const { autoSyncOnLoginLocal, savingAutoSync, saveAutoSyncOnLogin } = settingsStore;
</script>

<SettingsLayout activeTab="auto-sync" tabTitle="Auto Sync Invoice and Bill Status">
  <div class="flex items-center justify-between p-4 bg-white border border-gray-200 rounded-md">
    <div class="pr-4">
      <p class="text-sm font-medium text-gray-700">Automatically Process Status Syncs on Login</p>
      <p class="text-xs text-gray-500 mt-1">
        When enabled, pending Xero status changes will be synced to JobTread automatically each time you log in, without requiring manual confirmation.
      </p>
    </div>
    <div class="flex items-center gap-3 flex-shrink-0">
      <span class="text-sm font-bold {$autoSyncOnLoginLocal ? 'text-green-600' : 'text-red-600'}">
        {$autoSyncOnLoginLocal ? 'ON' : 'OFF'}
      </span>
      <label class="relative inline-flex items-center cursor-pointer">
        <input
          type="checkbox"
          checked={$autoSyncOnLoginLocal}
          on:change={(e) => saveAutoSyncOnLogin(e.target.checked)}
          disabled={$savingAutoSync}
          class="sr-only peer"
        />
        <div class="w-14 h-7 bg-red-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 rounded-full peer peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-6 after:w-6 after:transition-all peer-checked:bg-green-500 peer-disabled:opacity-50 peer-disabled:cursor-not-allowed"></div>
      </label>
    </div>
  </div>
</SettingsLayout>
